import { markRaw } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import { OrderManagementPage } from '@myorg/menu-editor-lib'
import api from '../../services/api'
import { orderManagementApi } from './merchantOrderApiImpl'
import { ROUTES, API_ENDPOINTS } from '@myorg/type-lib'
import type {
  UpdateStatusPayload,
  OrderHistoryResponse,
  CheckoutResult,
  OrderHistoryApi,
  OrderManagementApi,
  OrderStatus,
  MenuOrderApi,
  PaymentPayload,
} from '@myorg/type-lib'
import router from '../../router'
import i18n from '../../i18n'

/**
 * Menu API implementation
 */
export const menuApiImpl: MenuOrderApi = {
  getMenuByQr: async (qr: string) => {
    if (qr === '' || qr === ':qr') return
    const res = await api().get(API_ENDPOINTS.MENU.GET_MENU_BY_QR(qr))
    return res.data
  },
  submitOrder: async (payload: any) => {
    const res = await api().post(API_ENDPOINTS.MENU.ORDER_SUBMIT, payload)
    return res.data
  },
  handlePayment: async (payload: PaymentPayload) => {
    // 這裡通常是給前台使用的，後台管理頁面可能不需要完整實作，但為了符合介面仍需定義
    console.warn('handlePayment not fully implemented in OrderManagementPage')
    return false
  },
  getImages: async (id: string) => {
    const url = API_ENDPOINTS.BOOKING.PUBLIC_IMAGES.replace(':id', id)
    const res = await api().get(url)
    return res.data
  },
  queryCompanyName: async (ubn: string) => {
    const res = await api().get(API_ENDPOINTS.ECPAY.QUERY_COMPANY_NAME_PUBLIC(ubn))
    return res.data
  },
}

/**
 * Order history API implementation
 */
export const orderApiImpl: OrderHistoryApi = {
  getTableOrders: async (qr: string) => {
    const res = await api().get(API_ENDPOINTS.MENU.GET_ORDERS_BY_QR(qr))
    return res.data
  },
  getTableSessionOrders: async (qr: string) => {
    const res = await api().get(API_ENDPOINTS.MENU.GET_ORDERS_SESSION_BY_QR(qr))
    return res.data
  },
}


/**
 * Route config
 */
export const orderManagementRoute = {
  path: ROUTES.CHECKOUT.PATH,
  name: ROUTES.CHECKOUT.NAME,

  component: markRaw(OrderManagementPage),

  // required to satisfy RouteRecordRaw union
  children: [],

  props: (route) => ({
    orderManagementApi,
    menuApi: menuApiImpl,
    orderApi: orderApiImpl,
    qr: route.params.qr as string,
    onNavigate: (path: string) => router.push(path),
    t: i18n.global.t,
  }),
} satisfies RouteRecordRaw
